import { css } from "styled-components";
import { BUTTON_BORDER_SIZE } from "../Button.constants.js";
import { DefaultButtonProps } from "../Button.types.js";
import { getBorderRadius } from "./getBorderRadius.js";
import { getColor } from "./getColor.js";

export const borderGradientOnTransparentBackground = ({ color, size }: Pick<DefaultButtonProps, "color" | "size">) => {
    return css`
        border: none;

        &:before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            border-radius: ${(props) => getBorderRadius({ size, ...props })};
            border: ${BUTTON_BORDER_SIZE} solid transparent;
            background: ${(props) => getColor({ color, value: "100", ...props })} border-box;
            -webkit-mask:
                linear-gradient(#fff 0 0) padding-box,
                linear-gradient(#fff 0 0);
            mask:
                linear-gradient(#fff 0 0) padding-box,
                linear-gradient(#fff 0 0);
            -webkit-mask-composite: destination-out;
            mask-composite: exclude;
        }
    `;
};
